<template>
  <div id="tab5" class="tab active">
    <div class="padding">
      <div id="ui">
        <div class="padding ui-wrapper container">
          <div class="ui-main-text">
            <h1>
              A designer passionate about creating beautiful user friendly
              products
            </h1>
            <p>
              Hi, I'm <a href="/about">Ujjwal Verma</a>, UX Designer II at
              <a href="https://hashedin.com/" target="_blank"
                >HashedIn by Deloitte</a
              >. Designed
              <a
                href="https://www.afaqs.com/labs/result/foxglove-2021.html"
                target="_blank"
                >Foxglove Awards by Shutterstock 2021</a
              >
              Winning
              <a href="https://www.cobold.in/" target="_blank">Website</a>.
            </p>
          </div>
          <div>
            <div class="grid">
              <div v-for="(item, index) in list" :key="index">
                <div class="ui-cards">
                  <!-- <div :class="'site-link ' + item.showlink">
                  <a :href="item.url" target="_blank">
                    <div>Project</div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      id="link-svg"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-external-link"
                    >
                      <path
                        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                      ></path>
                      <polyline points="15 3 21 3 21 9"></polyline>
                      <line x1="10" y1="14" x2="21" y2="3"></line>
                    </svg>
                  </a>
                </div> -->
                  <router-link :to="{ name: 'item.url' }">
                    <img class="ui-img" :src="item.image" />
                    <img class="ui-shadow" :src="item.image" />

                    <div class="card-text">
                      <h4>{{ item.title }}</h4>
                      <p>{{ item.desc }}</p>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      list: [
        {
          image: "/img/gallery/ui/Runway.jpg",
          title: "Runway",
          desc: "Web Design | UI/UX | Incubator Brand",
          url: "/runway",
        },
        {
          image: "/img/gallery/ui/Swastik.jpg",
          title: "Swastik App",
          desc: "Web Design | UI/UX | Custom Shopping",
          url: "/swastik",
        },
        {
          image: "/img/gallery/ui/Cobold.jpg",
          title: "Cobold Digital",
          desc: "Web Design | UI/UX | Digital Agency",
          url: "/cobold",
        },
        {
          image: "/img/gallery/ui/ecoplore.jpg",
          title: "Ecoplore",
          desc: "Web Design | UI/UX | Travel",
          url: "/ecoplore",
          showlink: "showlink",
        },
        {
          image: "/img/gallery/ui/vj.jpg",
          title: "Vasundhra Jewellers",
          desc: "Web Design | UI/UX | Jewellery",
          url: "/vasundhra",
          showlink: "showlink",
        },
        // {
        //   image: "/img/gallery/ui/Concept.jpg",
        //   title: "Concepts",
        //   desc: "Web Design | UI/UX | Website Template",
        // },
        {
          image: "/img/gallery/ui/dhanam.jpg",
          title: "Dhanam",
          desc: "App Design | UI/UX",
          url: "/dhanam",
        },
        {
          image: "/img/gallery/ui/bound.jpg",
          title: "Bound",
          desc: "Branding | Design",
          url: "/bound",
        },
        {
          image: "/img/gallery/ui/Healing-gardens.jpg",
          title: "Healing Gardens",
          desc: "Web Design | UI/UX | Garden Event",
          url: "/Healinggarden",
        },
        {
          image: "/img/gallery/ui/zsites-full.jpg",
          title: "Zsites",
          desc: "Web Design | UI/UX | Website Creators",
          url: "/zsites",
          showlink: "showlink",
        },
        {
          image: "/img/gallery/ui/Max.jpg",
          title: "Max Square",
          desc: "Web Design | UI/UX | Real Estate",
          url: "/max",
          showlink: "showlink",
        },
        {
          image: "/img/gallery/ui/zsites.jpg",
          title: "Zsites - Landing Page",
          desc: "Web Design | UI/UX | Landing Page",
          url: "/zsites-landing",
          showlink: "showlink",
        },
        {
          image: "/img/gallery/ui/bsc.jpg",
          title: "Battle Station App",
          url: "/battlestations",
          desc: "App | UI/UX | Gaming",
        },
      ],
      selected: null,
      option: {
        getSortData: {
          id: "id",
        },
        sortBy: "id",
      },
    };
  },
};
</script>